function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import pathOr from 'ramda/src/pathOr';
import { getUiNotificationService } from 'invision-core/src/components/injectables/injector.helper';
import i18n from 'invision-core/src/components/i18n/i18n';
import { SUBSCRIBER_ID_HEADER } from 'invision-core/src/api/constants';
import { ThunkHelper } from 'invision-core';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import createWizardActions from '../helpers/offer.ordering.wizard.action.helper';
import { ContextOfferingAction, EDIT_WIZARD_PREFIX } from '../constants/wizard.constants';
import { RemoveOfferReasonCodes } from './../constants/transition.offer.wizard.constants';
import { beginEditOfferOrder as offerOrderBeginEditOrder, BEGIN_EDIT_OFFER_ORDER as OFFER_ORDER_BEGIN_ORDER, calculateChangeOfServiceOfferingOrderQuotePromise, getContractInstance, getContractId, setSelectedInventoryStores } from '../actions/offering.order.actions';
import { INVOICE_TIMING_CONSTANTS, REASON_CODES } from '../../customercare.constants';
import CustomerCareKeys from '../../locales/keys';
import { AddItemsSelector, ModifyItemsSelector, RemoveItemsSelector } from '../selectors/selected.offering.order.selectors';
var wizardActions = createWizardActions(EDIT_WIZARD_PREFIX);
export var BEGIN_EDIT_OFFER_ORDER = OFFER_ORDER_BEGIN_ORDER;
export var CANCEL_ORDER = wizardActions.CANCEL_WIZARD;
export var GO_TO_NEXT_STEP = wizardActions.GO_TO_NEXT_STEP;
export var GO_TO_PREVIOUS_STEP = wizardActions.GO_TO_PREVIOUS_STEP;
export var GO_TO_STEP = wizardActions.GO_TO_STEP;
export var RETRIEVE_ADDRESSES = wizardActions.RETRIEVE_ADDRESSES;
export var SAVE_OPTION_PRICING = wizardActions.SAVE_OPTION_PRICING;
export var SAVE_BWS_OPTION_EDIT = wizardActions.SAVE_BWS_OPTION_EDIT;
export var SEND_PORT_IN_OR_ITEM_RESERVATION = wizardActions.SEND_PORT_IN_OR_ITEM_RESERVATION;
export var SET_ATTRIBUTE_SEARCHING_INVENTORY = wizardActions.SET_ATTRIBUTE_SEARCHING_INVENTORY;
export var SET_CURRENT_STEP_IS_INVALID = wizardActions.SET_CURRENT_STEP_IS_INVALID;
export var SET_DECISIONS_REQUIRING_AFFECTED_SERVICES_RESOLUTION = 'SET_DECISIONS_REQUIRING_AFFECTED_SERVICES_RESOLUTION';
export var SET_EDIT_ATTRIBUTE_GROUPS = wizardActions.SET_EDIT_ATTRIBUTE_GROUPS;
export var SET_EDIT_OPTION = wizardActions.SET_EDIT_OPTION;
export var SET_EDIT_CART_ADDITIONAL_PROPERTY = wizardActions.SET_EDIT_CART_ADDITIONAL_PROPERTY;
export var SET_EDIT_CART_ADDITIONAL_PROPERTY_ON_CHANGE = wizardActions.SET_EDIT_CART_ADDITIONAL_PROPERTY_ON_CHANGE;
export var SET_EDIT_ORDER_ADDITIONAL_PROPERTY = wizardActions.SET_EDIT_ORDER_ADDITIONAL_PROPERTY;
export var SET_EDIT_ORDER_ADDITIONAL_PROPERTY_ON_CHANGE = wizardActions.SET_EDIT_ORDER_ADDITIONAL_PROPERTY_ON_CHANGE;
export var SET_EDIT_PHYSICAL_ATTRIBUTE_GROUPS = wizardActions.SET_EDIT_PHYSICAL_ATTRIBUTE_GROUPS;
export var SET_PAYMENT_INFO = wizardActions.SET_PAYMENT_INFO;
export var SET_SELECTED_EDIT_OFFER_TAB = wizardActions.SET_SELECTED_WIZARD_TAB;
export var SET_SELECTED_OFFER = wizardActions.SET_SELECTED_OFFER;
export var SET_SELECTED_OFFER_EDIT_COPY = wizardActions.SET_SELECTED_OFFER_EDIT_COPY;
export var UPDATE_EDIT_BRI_PRICE = wizardActions.UPDATE_EDIT_BRI_PRICE;
export var UPDATE_INVENTORY_SELECTION = wizardActions.UPDATE_INVENTORY_SELECTION;
export var UPDATE_OFFER_ATTRIBUTE = wizardActions.UPDATE_OFFER_ATTRIBUTE;
export var UPDATE_OFFER_PHYSICAL_INVENTORY_MAKE_AND_MODEL = wizardActions.UPDATE_OFFER_PHYSICAL_INVENTORY_MAKE_AND_MODEL;
export var UPDATE_OFFER_PHYSICAL_INVENTORY_TYPE_ATTRIBUTE = wizardActions.UPDATE_OFFER_PHYSICAL_INVENTORY_TYPE_ATTRIBUTE;
export var UPDATE_PAYMENT_INFO = wizardActions.UPDATE_PAYMENT_INFO;
export var UPDATE_PORT_IN_REQUEST = wizardActions.UPDATE_PORT_IN_REQUEST;
export var UPDATE_SELECTED_SERVICE_FEATURES = wizardActions.UPDATE_SELECTED_SERVICE_FEATURES;
export var beginEditOfferOrder = offerOrderBeginEditOrder;
export var cancelOrder = wizardActions.cancelWizard;
export var fetchAddresses = wizardActions.fetchAddresses;
export var fetchAttributes = wizardActions.fetchAttributes;
export var fetchWallet = wizardActions.fetchWallet;
export var goToNextStep = wizardActions.goToNextStep;
export var goToPreviousStep = wizardActions.goToPreviousStep;
export var goToStep = wizardActions.goToStep;
export var saveOptionEdit = wizardActions.saveOptionEdit;
export var saveBulkPricing = wizardActions.saveBulkPricing;
export var searchAttributeInventory = wizardActions.searchAttributeInventory;
export var sendPortInOrItemReservation = wizardActions.sendPortInOrItemReservation;
export var setCurrentStepIsInvalid = wizardActions.setCurrentStepIsInvalid;
export var setEditAttributeGroups = wizardActions.setEditAttributeGroups;
export var setEditOption = wizardActions.setEditOption;
export var setEditCartAdditionalProperty = wizardActions.setEditCartAdditionalProperty;
export var setEditCartAdditionalPropertyOnChange = wizardActions.setEditCartAdditionalPropertyOnChange;
export var setEditOrderAdditionalProperty = wizardActions.setEditOrderAdditionalProperty;
export var setEditOrderAdditionalPropertyOnChange = wizardActions.setEditOrderAdditionalPropertyOnChange;
export var setEditPhysicalAttributeGroups = wizardActions.setEditPhysicalAttributeGroups;
export var setPaymentInfo = wizardActions.setPaymentInfo;
export var setSelectedOffer = wizardActions.setSelectedOffer;
export var setSelectedOfferEditCopy = wizardActions.setSelectedOfferEditCopy;
export var setSelectedTab = wizardActions.setSelectedTab;
export var updateAttribute = wizardActions.updateAttribute;
export var updateBillCycle = wizardActions.updateBillCycle;
export var updateCart = wizardActions.updateCart;
export var updateEditOptionPrice = wizardActions.updateEditOptionPrice;
export var updateInventorySelection = wizardActions.updateInventorySelection;
export var updateOfferPhysicalInventoryMakeAndModel = wizardActions.updateOfferPhysicalInventoryMakeAndModel;
export var updateOfferPhysicalInventoryTypeAttribute = wizardActions.updateOfferPhysicalInventoryTypeAttribute;
export var updatePaymentInfo = wizardActions.updatePaymentInfo;
export var updatePortInRequest = wizardActions.updatePortInRequest;
export var updateSelectedServiceFeatures = wizardActions.updateSelectedServiceFeatures;
var retrieveOfferingContextPromise = function retrieveOfferingContextPromise(dispatch, customerId, data, STATUSES_ARRAY) {
  return ThunkHelper(dispatch, STATUSES_ARRAY, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOfferingContext',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: data
  });
};
var handleEditRetrievePreviousAttributesPromise = function handleEditRetrievePreviousAttributesPromise(dispatch, customerId, offeringId, offeringInstanceId, isConvergentBiller, isReconnectAction) {
  return editRetrievePreviousAttributesPromise(dispatch, customerId, offeringId, offeringInstanceId, null, isConvergentBiller, isReconnectAction).then(function (response) {
    if (response.Context.ValueDecisions.length > 0 || response.Context.PhysicalInventoryDecisions.length > 0) {
      dispatch(goToStep([CustomerCareKeys.WIZARD.STEPS.ATTRIBUTES, true]));
    } else {
      dispatch(goToStep([CustomerCareKeys.WIZARD.STEPS.CHECKOUT, true]));
    }
  });
};
export var EDIT_INITIAL_OFFERING_CONTEXT = {
  BEGIN: 'EDIT_INITIAL_OFFERING_CONTEXT_BEGIN',
  SUCCESS: 'EDIT_INITIAL_OFFERING_CONTEXT_SUCCESS',
  FAILURE: 'EDIT_INITIAL_OFFERING_CONTEXT_FAILURE'
};
var EDIT_INITIAL_OFFERING_CONTEXT_TYPES = [EDIT_INITIAL_OFFERING_CONTEXT.BEGIN, EDIT_INITIAL_OFFERING_CONTEXT.SUCCESS, EDIT_INITIAL_OFFERING_CONTEXT.FAILURE];
export var fetchPreviousDecisionsPromise = function fetchPreviousDecisionsPromise(dispatch, customerId, offeringId, offeringInstanceId) {
  var completedDecisions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var isConvergentBiller = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var isReconnectAction = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var data = {
    Offerings: [{
      Action: isReconnectAction ? ContextOfferingAction.RECONNECT : ContextOfferingAction.MODIFY,
      OfferingId: offeringId,
      OfferingInstanceId: offeringInstanceId
    }],
    AdditionalShoppingCartUpdate: !isConvergentBiller,
    RetrieveServiceAttributes: false,
    RetrievePhysicalInventoryDecisions: false,
    CompletedDecisionsList: completedDecisions,
    ContractId: getContractId(),
    OrderContractInstance: getContractInstance(offeringId)
  };
  return ThunkHelper(dispatch, EDIT_INITIAL_OFFERING_CONTEXT_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOfferingContext',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: data
  });
};
export var fetchPreviousDecisionsAndNavigate = function fetchPreviousDecisionsAndNavigate(customerId, offeringId, offeringInstanceId) {
  var emptyDecisionGroups = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var isConvergentBiller = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var isReconnectAction = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  return function (dispatch) {
    // Disallow the user from submitting again until the request is done
    dispatch(setCurrentStepIsInvalid(true));
    dispatch(setSelectedOffer(offeringId));
    dispatch(setSelectedOfferEditCopy(offeringId));
    var previousDecisionsPromise = Promise.resolve();
    if (emptyDecisionGroups === null) {
      previousDecisionsPromise = previousDecisionsPromise.then(function () {
        return fetchPreviousDecisionsPromise(dispatch, customerId, offeringId, offeringInstanceId, emptyDecisionGroups, isConvergentBiller, isReconnectAction);
      }).then(function (response) {
        if (!response.Context.Decisions.length) {
          return handleEditRetrievePreviousAttributesPromise(dispatch, customerId, offeringId, offeringInstanceId, isConvergentBiller, isReconnectAction);
        }
      });
    } else if (emptyDecisionGroups) {
      previousDecisionsPromise = previousDecisionsPromise.then(function () {
        return handleEditRetrievePreviousAttributesPromise(dispatch, customerId, offeringId, offeringInstanceId, isConvergentBiller, isReconnectAction);
      });
    }
    previousDecisionsPromise.catch(function (error) {
      getUiNotificationService().transientError(error.translatedMessage !== error.Code.toString() ? error.translatedMessage : i18n.translate(CustomerCareKeys.DECISIONS_ERROR));
    }).finally(function () {
      // Make it ok for the user to submit again
      dispatch(setCurrentStepIsInvalid(false));
    });
    return previousDecisionsPromise;
  };
};
export var EDIT_RETRIEVE_PREVIOUS_ATTRIBUTES = {
  BEGIN: 'EDIT_RETRIEVE_PREVIOUS_ATTRIBUTES_BEGIN',
  SUCCESS: 'EDIT_RETRIEVE_PREVIOUS_ATTRIBUTES_SUCCESS',
  FAILURE: 'EDIT_RETRIEVE_PREVIOUS_ATTRIBUTES_FAILURE'
};
var EDIT_RETRIEVE_PREVIOUS_ATTRIBUTES_TYPES = [EDIT_RETRIEVE_PREVIOUS_ATTRIBUTES.BEGIN, EDIT_RETRIEVE_PREVIOUS_ATTRIBUTES.SUCCESS, EDIT_RETRIEVE_PREVIOUS_ATTRIBUTES.FAILURE];
var editRetrievePreviousAttributesPromise = function editRetrievePreviousAttributesPromise(dispatch, customerId, offeringId, offeringInstanceId) {
  var completedDecisions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var isConvergentBiller = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var isReconnectAction = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var data = {
    Offerings: [{
      Action: isReconnectAction ? ContextOfferingAction.RECONNECT : ContextOfferingAction.MODIFY,
      OfferingId: offeringId,
      OfferingInstanceId: offeringInstanceId
    }],
    AdditionalShoppingCartUpdate: !isConvergentBiller,
    RetrieveServiceAttributes: true,
    RetrievePaymentInstrument: true,
    RetrieveDeliveryDecisions: true,
    RetrievePhysicalInventoryDecisions: true,
    CompletedDecisionsList: completedDecisions,
    ContractId: getContractId(),
    OrderContractInstance: getContractInstance(offeringId)
  };
  return retrieveOfferingContextPromise(dispatch, customerId, data, EDIT_RETRIEVE_PREVIOUS_ATTRIBUTES_TYPES);
};
export var fetchPreviousAttributesAndNavigate = function fetchPreviousAttributesAndNavigate(customerInfo, offeringId, offeringInstanceId, completedDecisions) {
  var isConvergentBiller = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var isReconnectAction = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var bypassQuote = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  return function (dispatch, getState) {
    // Disallow the user from submitting again until the request is done
    dispatch(setCurrentStepIsInvalid(true));
    return editRetrievePreviousAttributesPromise(dispatch, customerInfo.Id, offeringId, offeringInstanceId, completedDecisions, isConvergentBiller, isReconnectAction).then(function (response) {
      var visibleValueDecisions = response.Context.ValueDecisions.filter(function (decision) {
        // if there is a DependentServiceAttributeId then the attribute is hidden
        // if they are all hidden, then we don't need to show attributes page
        return !decision.DependentServiceAttributeId;
      });
      var addItems = AddItemsSelector(getState());
      var modifyItems = ModifyItemsSelector(getState());
      var removeItems = RemoveItemsSelector(getState());
      if (visibleValueDecisions.length > 0 || response.Context.PhysicalInventoryDecisions.length > 0) {
        dispatch(goToNextStep());
      } else {
        var reasonCode = isReconnectAction ? convertStringToNumber(REASON_CODES.RECONNECT) : null;
        return calculateChangeOfServiceOfferingOrderQuotePromise(dispatch, customerInfo, offeringId, addItems, removeItems, modifyItems, undefined, reasonCode, undefined, undefined, bypassQuote).then(function () {
          dispatch(goToStep(CustomerCareKeys.WIZARD.STEPS.CHECKOUT));
        }).catch(function (error) {
          getUiNotificationService().transientError(error.translatedMessage);
        });
      }
    }).catch(function (error) {
      getUiNotificationService().transientError(error.translatedMessage !== error.Code.toString() ? error.translatedMessage : i18n.translate(CustomerCareKeys.DECISIONS_ERROR));
    }).finally(function () {
      // Make it ok for the user to submit again
      dispatch(setCurrentStepIsInvalid(false));
    });
  };
};
export var fetchAttributesQuote = function fetchAttributesQuote(customerId, offeringId, offeringInstanceId) {
  var completedDecisions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var completedAttributes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var completedPhysicalAttributes = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var isConvergentBiller = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var isReconnectAction = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  return function (dispatch) {
    return editRetrievePreviousAttributesPromise(dispatch, customerId, offeringId, offeringInstanceId, completedDecisions.concat(completedAttributes).concat(completedPhysicalAttributes), isConvergentBiller, isReconnectAction);
  };
};
export var EDIT_SUBMIT_COS_ORDER = {
  BEGIN: 'EDIT_SUBMIT_COS_ORDER_BEGIN',
  SUCCESS: 'EDIT_SUBMIT_COS_ORDER_SUCCESS',
  FAILURE: 'EDIT_SUBMIT_COS_ORDER_FAILURE'
};
var EDIT_SUBMIT_COS_ORDER_TYPES = [EDIT_SUBMIT_COS_ORDER.BEGIN, EDIT_SUBMIT_COS_ORDER.SUCCESS, EDIT_SUBMIT_COS_ORDER.FAILURE];
export var editOfferSubmitCosOrder = function editOfferSubmitCosOrder(customerId, offeringId, offeringInstanceId, addItems, modifyItems, removeItems, paymentInfo, changesEffective, executionOptions, recordPaymnetInfo, isReconnectOffer, pickupId, additionalProperties, shippingInfo, orderDetails) {
  return function (dispatch) {
    return editOfferSubmitCosOrderPromise(dispatch, customerId, offeringId, offeringInstanceId, addItems, modifyItems, removeItems, paymentInfo, changesEffective, executionOptions, recordPaymnetInfo, isReconnectOffer, pickupId, additionalProperties, shippingInfo, orderDetails);
  };
};
export var editOfferSubmitCosOrderPromise = function editOfferSubmitCosOrderPromise(dispatch, customerId, offeringId, offeringInstanceId, addItems, modifyItems, removeItems, paymentInfo, changesEffective, executionOptions, recordPaymentInformation, isReconnectOffer, pickupId, additionalProperties) {
  var shippingInfo = arguments.length > 14 && arguments[14] !== undefined ? arguments[14] : {};
  var orderDetails = arguments.length > 15 && arguments[15] !== undefined ? arguments[15] : {};
  var paymentInfoArray = paymentInfo ? [paymentInfo] : [];
  var data = {
    AddItems: addItems,
    AdditionalProperties: additionalProperties || null,
    ChangeImmediately: true,
    Comment: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.comment) || null,
    ExecutionDate: executionOptions.specifiedDate,
    ExecutionDateIntention: executionOptions.effective,
    ModifyItems: modifyItems,
    OfferingId: offeringId,
    OfferingInstanceId: offeringInstanceId,
    PaymentInstruments: paymentInfoArray,
    ReasonCode: isReconnectOffer ? REASON_CODES.RECONNECT : orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.reasonCode,
    RecordPaymentInformation: recordPaymentInformation,
    RemoveItems: removeItems,
    PickupId: pickupId || null,
    ShippingAddressId: shippingInfo.addressId || undefined,
    ShippingAddress: shippingInfo.address || undefined,
    ShippingMethodId: shippingInfo.methodId || undefined,
    ShipToName: shippingInfo.shipTo || undefined
  };
  if (+changesEffective === INVOICE_TIMING_CONSTANTS.INVOICE_ON_CYCLE) {
    data.ChangeImmediately = false;
  }
  if (removeItems.length) {
    data.RemoveReasonCode = RemoveOfferReasonCodes.DefaultedToRemove;
  }
  return ThunkHelper(dispatch, EDIT_SUBMIT_COS_ORDER_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/SubmitChangeOfServiceOrder',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: data
  });
};
export var setDecisionsRequiringAffectedServicesResolution = function setDecisionsRequiringAffectedServicesResolution(decisions) {
  return {
    type: SET_DECISIONS_REQUIRING_AFFECTED_SERVICES_RESOLUTION,
    payload: decisions
  };
};
export var RETRIEVE_DECISION_OPTION_SERVICE_IDS = {
  BEGIN: 'RETRIEVE_DECISION_OPTION_SERVICE_IDS_BEGIN',
  SUCCESS: 'RETRIEVE_DECISION_OPTION_SERVICE_IDS_SUCCESS',
  FAILURE: 'RETRIEVE_DECISION_OPTION_SERVICE_IDS_FAILURE'
};
var RETRIEVE_DECISION_OPTION_SERVICE_IDS_TYPES = [RETRIEVE_DECISION_OPTION_SERVICE_IDS.BEGIN, RETRIEVE_DECISION_OPTION_SERVICE_IDS.SUCCESS, RETRIEVE_DECISION_OPTION_SERVICE_IDS.FAILURE];
export var retrieveDecisionOptionServiceIds = function retrieveDecisionOptionServiceIds(customerId, decisionOptionIds, offeringInstanceId) {
  return function (dispatch) {
    return retrieveDecisionOptionServiceIdsPromise(dispatch, customerId, decisionOptionIds, offeringInstanceId);
  };
};
export var retrieveDecisionOptionServiceIdsPromise = function retrieveDecisionOptionServiceIdsPromise(dispatch, customerId, decisionOptionIds, offeringInstanceId) {
  return ThunkHelper(dispatch, RETRIEVE_DECISION_OPTION_SERVICE_IDS_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveConvergentBillerServices',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {
      DecisionOptionIds: decisionOptionIds,
      OfferingInstanceId: offeringInstanceId
    }
  });
};
export var SET_IS_RESUMING_ORDER = 'SET_IS_RESUMING_ORDER';
export var setIsResumingOrder = function setIsResumingOrder(resumingOrder) {
  return {
    type: SET_IS_RESUMING_ORDER,
    payload: resumingOrder
  };
};
export var SET_IS_RESUMING_STORE_ORDER_FOR_EDIT_OFFER = 'SET_IS_RESUMING_STORE_ORDER_FOR_EDIT_OFFER';
export var setIsResumingStoreOrderForEditOffer = function setIsResumingStoreOrderForEditOffer(resumingOrder) {
  return {
    type: SET_IS_RESUMING_STORE_ORDER_FOR_EDIT_OFFER,
    payload: resumingOrder
  };
};
export var SET_PHYSICAL_INVENTORY_ID = 'SET_PHYSICAL_INVENTORY_ID';
export var setPhysicalInventoryId = function setPhysicalInventoryId(InventoryId) {
  return {
    type: SET_PHYSICAL_INVENTORY_ID,
    payload: InventoryId
  };
};

//first store order resume
export var RESUME_STORE_ORDER_FOR_DECISIONS_FOR_EDIT = {
  BEGIN: 'RESUME_STORE_ORDER_BEGIN_FIRST',
  SUCCESS: 'RESUME_STORE_ORDER_SUCCESS_FIRST',
  FAILURE: 'RESUME_STORE_ORDER_FAILURE_FIRST'
};
export var RESUME_STORE_ORDER_EVENTS_FOR_DECISIONS_FOR_EDIT = [RESUME_STORE_ORDER_FOR_DECISIONS_FOR_EDIT.BEGIN, RESUME_STORE_ORDER_FOR_DECISIONS_FOR_EDIT.SUCCESS, RESUME_STORE_ORDER_FOR_DECISIONS_FOR_EDIT.FAILURE];
export var RESUME_STORE_ORDER_FOR_INVENTORY_AND_ATTRIBUTES_DECISIONS_FOR_EDIT = {
  BEGIN: 'RESUME_STORE_ORDER_BEGIN_SECOND',
  SUCCESS: 'RESUME_STORE_ORDER_SUCCESS_SECOND',
  FAILURE: 'RESUME_STORE_ORDER_FAILURE_SECOND'
};
export var RESUME_STORE_ORDER_EVENTS_FOR_INVENTORY_AND_ATTRIBUTES_DECISIONS_FOR_EDIT = [RESUME_STORE_ORDER_FOR_INVENTORY_AND_ATTRIBUTES_DECISIONS_FOR_EDIT.BEGIN, RESUME_STORE_ORDER_FOR_INVENTORY_AND_ATTRIBUTES_DECISIONS_FOR_EDIT.SUCCESS, RESUME_STORE_ORDER_FOR_INVENTORY_AND_ATTRIBUTES_DECISIONS_FOR_EDIT.FAILURE];
var resumeStoreOrderForDecisionsPromise = function resumeStoreOrderForDecisionsPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, RESUME_STORE_ORDER_EVENTS_FOR_DECISIONS_FOR_EDIT, {
    method: 'post',
    url: 'SubscriberManagement/ResumeStoreOrder',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {
      RetrievePhysicalInventoryDecisions: false,
      RetrieveServiceAttributes: false
    }
  });
};
var resumeStoreOrderForInventoryAttributesDecisionsPromise = function resumeStoreOrderForInventoryAttributesDecisionsPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, RESUME_STORE_ORDER_EVENTS_FOR_INVENTORY_AND_ATTRIBUTES_DECISIONS_FOR_EDIT, {
    method: 'post',
    url: 'SubscriberManagement/ResumeStoreOrder',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {
      RetrievePhysicalInventoryDecisions: true,
      RetrieveDeliveryDecisions: true,
      RetrieveServiceAttributes: true
    }
  });
};
export var resumeStoreOrder = function resumeStoreOrder(customerInfo) {
  return function (dispatch) {
    return resumeStoreOrderForDecisionsPromise(dispatch, customerInfo.Id).then(function (response) {
      var pickupId = pathOr(null, ['ShoppingCart', 'SubscriberPhysicalInventoryPickupDetail', 'Id'], response);
      if (pickupId) {
        var physicalInventoryItemWithStore = response.ShoppingCart.Items.find(function (item) {
          return pathOr(null, ['PhysicalInventories', 0, 'StoreId'], item);
        });
        if (physicalInventoryItemWithStore) {
          dispatch(setSelectedInventoryStores([physicalInventoryItemWithStore.PhysicalInventories[0].StoreId.toString()]));
        }
      }
      return resumeStoreOrderForInventoryAttributesDecisionsPromise(dispatch, customerInfo.Id);
    }).then(function (response) {
      var pickupId = pathOr(null, ['ShoppingCart', 'SubscriberPhysicalInventoryPickupDetail', 'Id'], response);
      if (pickupId) {
        var physicalInventoryItemWithStore = response.ShoppingCart.Items.find(function (item) {
          return pathOr(null, ['PhysicalInventories', 0, 'StoreId'], item);
        });
        if (physicalInventoryItemWithStore) {
          dispatch(setSelectedInventoryStores([physicalInventoryItemWithStore.PhysicalInventories[0].StoreId.toString()]));
        }
      }
      dispatch(goToStep(CustomerCareKeys.WIZARD.STEPS.DECISIONS), true);
    });
  };
};
export var SET_SERVICE_TAX_LOCATION_DECISION_EDIT_OFFER = 'SET_SERVICE_TAX_LOCATION_DECISION_EDIT_OFFER';
export var updateServiceTaxLocationDecisionEditOffer = function updateServiceTaxLocationDecisionEditOffer(payload) {
  return {
    type: SET_SERVICE_TAX_LOCATION_DECISION_EDIT_OFFER,
    payload: payload
  };
};